export default "__VITE_ASSET__BpG9zDb2__"